<template>
	<div class="text">
		<div class="h4">直达运动平台服务协议及隐私政策</div> 
		<div>运营主体：山西弛方电子商务有限公司</div> 
		<div>平台官网：www.zhidayd.com</div> 
		<div>生效日期：2026 年 3 月 15 日</div> 
		<div>审慎阅读提示：本文件包含《直达运动平台服务协议》与《直达运动平台隐私政策》全部核心内容，是您与运营主体间的正式法律约定。请仔细阅读所有条款，重点关注免除 / 限制责任、个人信息保护、法律管辖等内容，如有疑问可联系平台客服。完成平台注册并使用服务，即视为您已充分阅读、理解并接受本文件全部内容。</div> 
		<div>第一部分 直达运动平台服务协议</div> 
		<div>一、定义</div> 
		<div>直达运动平台：由山西弛方电子商务有限公司及其关联方合法运营的www.zhidayd.com网站及客户端应用程序，服务所有权、运作权属运营主体，按平台发布规则执行。</div> 
		<div>平台服务：为您提供的货品搜索、采购交易、数据查询、售后协助等 B2B 商业团购配套服务。</div> 
		<div>平台规则：平台规则频道、帮助中心等板块已发布及后续更新的所有规则、公告、解读内容。</div> 
		<div>关联公司：与山西弛方电子商务有限公司存在直接 / 间接控制或重大影响关系的公司。</div> 
		<div>二、用户资格与账户管理</div> 
		<div>用户资格：需具备中华人民共和国法定民事行为能力及合法经营主体资质，非贸易限制、经济制裁等法律法规限制对象，否则立即停止使用平台服务。</div> 
		<div>账户注册与使用：按平台提示填写真实、完整、有效信息并通过审核，可获得平台账户；平台可要求完成实名认证，账户仅限本人使用，不得转让，您对账户下所有行为结果承担全部责任。</div> 
		<div>账户维护与回收：注册信息变更需在变更前 3 个工作日联系平台客服；平台不会主动索要账户密码，因您泄露或外部攻击导致的账户损失，平台不承担责任。账户同时满足未按要求提供信息、连续 1 个月无交易，平台有权回收，账户停用且相关服务终止。</div> 
		<div>三、平台服务及交易规范</div> 
		<div>商品浏览与识别：平台提供信息分类、检索、筛选功能，仓位名称含 “直达运动” 的为平台自营产品，其余为第三方商家 / 外货源仓位，具体以平台 “帮助中心 - 售后服务” 规则为准。</div> 
		<div>商品采购规则</div> 
		<div>下单前确认商品仓位、规格、价格及收货信息，非本人收货需确认系实际收货人的真实意思表示，否则自行承担纠纷后果；购买行为基于真实经营需求，不得恶意购买、维权，平台发现后可直接关闭相关订单。</div> 
		<div>平台展示商品为要约邀请，您提交订单为要约，商家发货为承诺，买卖关系自发货时成立；付款后非法定或双方协商一致的，不得取消订单，否则按订单总额 30% 支付违约金，平台可从您的账户 / 货款中直接扣除。</div> 
		<div>商品缺货、价格标错等非平台过错导致商家无法发货的，平台可通知您取消订单并全额退款，不承担违约责任；平台系统可自动拦截、取消异常 / 有风险订单，已付款的将及时退款。</div> 
		<div>售后服务规范</div> 
		<div>非质量问题：数量、颜色、规格等问题需在收货当天提出异议，24 小时内未协商一致的，需在 24 小时内退回商品（包装、吊牌完整，无使用、污渍痕迹，不影响二次销售），平台验收后重新发货，运费由平台承担；逾期未提出异议或实际使用商品的，视为对商品无异议。</div> 
		<div>质量问题：需在收货 7 日内提出异议，逾期视为验收合格；自营仓商品质量问题，平台 7 日内核实并协商处理（退货退款、换货、合理补偿等）；第三方仓位商品质量问题，平台仅协助与商家沟通，不承担最终解决责任。</div> 
		<div>退换货需保证商品及附属品完好，鞋类商品需原装鞋盒完整无破损，否则平台有权拒绝退换货申请；退款需归还平台开具的发票（如有）及商品，平台验收无误后 7 个工作日内退还货款。</div> 
		<div>因采购平台货品经营、销售引发的商标侵权、售假等违法行为，由您自行承担全部责任，给平台造成损失的，平台有权全额追偿。</div> 
		<div>四、禁止行为与违约处理</div> 
		<div>禁止行为：不得在平台发布电脑病毒、恶意代码等有害信息；不得未经授权收集其他用户信息、恶意占用服务器资源、干扰他人使用平台；不得向平台及关联方工作人员进行商业贿赂，否则平台可立即终止合作并要求赔偿。</div> 
		<div>违约认定：使用平台服务违反国家法律法规，或违反本协议及平台规则约定的，即视为违约。</div> 
		<div>违约处理措施</div> 
		<div>发布信息违约的，平台可直接删除、屏蔽相关信息；行为违约的，平台有权终止提供全部 / 部分服务。</div> 
		<div>违约且存在欺诈、售假、盗用他人账户等情形的，平台可对账户采取取消收款、资金止付等强制措施，并公示违约处理结果及行政 / 司法机关确认的违法信息。</div> 
		<div>违约行为给平台及关联公司造成损失（含直接经济损失、商誉损失、律师费、诉讼费等间接损失）的，应全额赔偿；平台向第三方承担责任后，可全额追偿，并有权从您的账户中冻结、扣划赔偿款项。</div> 
		<div>五、争议处理与法律适用</div> 
		<div>争议处理途径：与平台 / 第三方商家发生交易争议，可通过双方自主协商、平台调处、向相关行政部门投诉、向忻州市忻府区人民法院提起诉讼解决；平台客服仅按普通人认知及平台规则调处，除故意或重大过失外，不对调处结果承担责任。</div> 
		<div>法律适用与管辖：本协议订立、生效、解释、争议解决等均适用中华人民共和国大陆地区法律，无相关规定的参照商业 / 行业惯例；所有争议协商不成的，任何一方均有权向忻州市忻府区人民法院提起诉讼。</div> 
		<div>六、协议变更、终止与通用约定</div> 
		<div>协议变更：平台可根据法律法规及运营需要修改本协议，变更内容通过平台公告、短信、邮箱等方式通知；您若不同意变更，应在生效后停止使用平台服务，继续使用即视为同意变更内容。</div> 
		<div>协议终止</div> 
		<div>您可在满足平台条件时，通过自助服务注销账户，或明示不愿使用服务并符合终止条件的，可终止本协议。</div> 
		<div>您违反本协议、存在欺诈 / 严重违法违约行为的，平台可通过本协议约定方式通知终止协议。</div> 
		<div>协议终止后，您的平台使用权利立即终止，除法律法规另有规定外，平台无义务披露您的账户信息；平台可继续保存您的账户信息，对过往违约行为仍有权依据本协议追究责任。</div> 
		<div>通用免责：平台对台风、地震、战争等不可抗力，黑客攻击、电信 / 银行故障、网站升级等第三方原因，或平台尽善意管理后的设备维护、系统故障等导致的服务中断、交易履行障碍，不承担违约责任；非平台故意导致服务未提供，或因您的过失导致自身 / 第三方损失的，平台不承担赔偿责任。</div> 
		<div>通知送达：您应提供真实、有效的联系方式（电话、邮箱、地址等）并及时更新；平台通过官网公告、短信、邮箱、系统消息等电子方式发出的通知，发送成功即视为送达；纸质通知按您提供地址交邮后第 3 个自然日视为送达。</div> 
		<div>第二部分 直达运动平台隐私政策</div> 
		<div>一、核心原则</div> 
		<div>运营主体山西弛方电子商务有限公司充分尊重并保护您的个人信息，遵循正当、合法、必要、最小化原则收集、使用、保存个人信息，未经您事先许可，不向无关第三方披露、提供您的个人信息。本政策为平台服务协议不可分割的一部分，使用平台服务即视为同意本政策全部内容。</div> 
		<div>二、个人信息的收集与使用</div> 
		<div>收集范围与方式</div> 
		<div>注册主动提供：注册账号时的联系方式、电子邮箱、企业信息，企业认证所需的营业执照、统一社会信用代码、注册地址等敏感个人信息。</div> 
		<div>使用自动记录：使用平台服务、访问网页时，平台自动接收并记录的 IP 地址、浏览器类型、访问时间、软硬件特征、网页浏览记录等数据。</div> 
		<div>增值服务授权收集（不提供不影响基础服务）：开启位置权限的位置信息（匹配产品 / 服务展示）；开启相机 / 摄像头权限的扫码、拍摄、人脸识别信息（面部特征仅在授权范围内使用，新增用途将再次确认）；开启通讯录权限的联系人信息（方便取用，经同意后加密收集用于判断平台会员关系）。</div> 
		<div>合法第三方获取：通过合法途径从商业伙伴处取得的相关个人数据。</div> 
		<div>使用目的</div> 
		<div>完成账户注册，提供平台各项服务功能；</div> 
		<div>优化平台产品 / 服务体验，开发贴合用户需求的功能；</div> 
		<div>发送平台产品 / 服务通用信息，与合作伙伴共享信息发送相关内容（需事先征得您同意）；</div> 
		<div>法律法规允许或您事先同意的其他合法目的。</div> 
		<div>信息处理说明：平台无用户画像定向推送功能，所有用户商品展示、推荐内容一致；对收集的个人信息做去标识化 / 匿名化处理，处理后数据可用于平台大数据分析、服务优化等，若将非个人信息与其他信息结合识别出您的个人身份，将按本政策严格保护。</div> 
		<div>三、个人信息的共享、转让与公开披露</div> 
		<div>共享：不与无关公司、组织、个人共享个人信息，除外情形：获得您的明确同意；依据法律法规或司法机关、政府主管部门强制性要求；与平台关联公司共享（仅必要信息，受本政策约束）；与授权合作伙伴共享（仅为实现本政策目的，签署保密协议约束第三方）；处理知识产权投诉、用户间纠纷 / 争议的必要共享。</div> 
		<div>转让：不向任何公司、组织、个人转让个人信息，除外情形：获得您的明确同意；涉及平台合并、收购、破产清算时，需转让的将要求接收方重新征求您的授权，并告知接收方信息、处理目的 / 方式 / 种类。</div> 
		<div>公开披露：仅在获得您的明确同意、依据法律法规 / 司法机关 / 政府主管部门强制性要求，或法律、法规 / 平台规则规定的其他合理情形下，公开披露个人信息。</div> 
		<div>四、个人信息的保护与管理</div> 
		<div>平台保护措施：对账户密码加密处理，设置严格的信息访问权限控制和监控机制，仅允许必要知晓的员工、合作伙伴访问个人信息并要求其履行保密义务；制定个人信息泄露、损毁、丢失的应急处理制度，设立专门应急响应团队，发生安全事件后，按法律法规要求及时告知您事件情况、处置措施，并向监管部门上报结果。</div> 
		<div>用户自主管理</div> 
		<div>查询 / 更正 / 补充：登录平台账户，在个人中心直接操作；无法线上操作的，可通过本政策约定方式联系平台协助。</div> 
		<div>注销账户：登录平台账户，在设置菜单提交注销申请并完成操作；账户注销后，平台停止提供服务，除法律法规另有规定外，永久删除您的个人信息，账户注销后不可恢复，如需再次使用需重新注册。</div> 
		<div>信息留存与销毁：个人信息超出保留期限后，按法律法规要求删除或匿名化处理；您在交易中向第三方披露个人信息的，需自行妥善保护，发现账号、密码泄露请立即联系平台客服采取补救措施。</div> 
		<div>五、政策更新与联系我们</div> 
		<div>政策更新：平台可根据法律法规及运营需要更新本政策，未经您明确同意，不削减您依据本政策享有的权利；发生重大变更（服务模式、信息处理方式、共享对象等变化）时，将通过平台公告、短信、邮箱等显著方式告知，您继续使用平台服务即视为接受更新内容，平台将存档旧版本供查阅。</div> 
		<div>联系我们：对本政策、个人信息处理有疑问、意见、建议，或需投诉、举报，可通过平台公示的个人信息保护负责人邮箱、联系电话、联系地址联系，我们将在15 个工作日内回复；对回复不满意的，可向网信、电信、公安等监管部门投诉举报。</div> 
		<div>附：个人信息及敏感个人信息示例</div> 
		<div>敏感个人信息：生物识别信息（人脸、指纹、声纹等）、宗教信仰信息、残障人士等特定身份信息、医疗健康信息（病症、体检报告、就诊记录等）、金融账户信息（银行账号、支付密码、征信信息等）、行踪轨迹信息（精准定位、车辆行驶轨迹等）、不满十四周岁未成年人个人信息、居民身份证照片、犯罪记录信息等。</div> 
		<div>个人信息：姓名、电话、住址、邮箱等基本资料，身份证、驾驶证等身份信息，账号、IP 地址等网络标识信息，学历、职业等教育工作信息，房产、交易记录等财产信息，短信、邮件等通信信息，通讯录、好友列表等联系人信息，浏览记录、收藏列表等上网记录，设备序列号、MAC 地址等常用设备信息，经纬度、住宿信息等位置信息，婚史、性取向等其他信息。</div> 
		<div>本文件最终解释权归山西弛方电子商务有限公司所有，平台将依法履行信息安全保障义务，保护您的合法权益。</div> 
	</div>
</template>

<script>
	export default {
		name: 'Rtext',
		data() {
			return {}
		}
	}
</script>

<style scoped lang="less">
	.text {
		width: 100%;
		.h4 {
			width: 100%;
			text-align: center;
			font-size: 20px;
			font-weight: bold;
		}
	}
</style>


// WEBPACK FOOTER //
// src/common/rtext.vue